import { useState } from 'react';
import Icon from '@components/common/assets';
import Colors from '@domain/constant/colors';

import classnames from 'classnames/bind';
import styles from './index.module.scss';
const cx = classnames.bind(styles);

interface Props {
  isLiked: boolean;
  size?: number;
  onClick: () => Promise<void>;
}

const LikeButton = ({ isLiked, size = 24, onClick }: Props) => {
  const [isAnimationEnabled, setIsAnimationEnabled] = useState(false);

  const handleClick = async () => {
    await onClick();
    if (!isAnimationEnabled) {
      setIsAnimationEnabled(true);
    }
  };

  return (
    <a
      className={cx('likeBtn', {
        likeAnimation: isAnimationEnabled && isLiked,
        unlikeAnimation: isAnimationEnabled && !isLiked,
      })}
      role="button"
      onClick={handleClick}
    >
      {isLiked ? (
        <Icon name="heartLightFilled" width={size} height={size} fill={Colors.C_ERROR} />
      ) : (
        <Icon name="heartLight" width={size} height={size} />
      )}
    </a>
  );
};

export default LikeButton;
